import React from 'react';
import { Helmet } from 'react-helmet';
import Money from '../../../../components/Money';

/* eslint-disable react/prop-types */
const Header = ({ shopName, loyaltyAmount }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Loyalty Program | {shopName}</title>
    </Helmet>
    Thank you for being a loyal customer, you just earned&nbsp;
    <Money noDecimalsIfInt>{loyaltyAmount}</Money>
    &nbsp;in loyalty rewards!
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyGrant/components/Header.jsx